import { catchError, map } from 'rxjs/operators';
import { concat, Observable, of, throwError } from 'rxjs';
import { ESP_PRICE_SERVICE } from '../pricing/esp-price';
import { FWD_PRICE_SERVICE } from '../pricing/fwd-price';
import { inject, injectable } from 'inversify';
import { IPriceProviderQuote, IPriceProviderService } from './price-provider.interface';
import { IPriceService, IQuoteRequest } from '../../interfaces';
import { MonoAction } from '../../interfaces/functions.interface';

export const EMPTY_QUOTE = { isStarted: false } as IPriceProviderQuote;

@injectable()
export class PriceProviderService implements IPriceProviderService {

    @inject(ESP_PRICE_SERVICE) private readonly espPriceService: IPriceService;
    @inject(FWD_PRICE_SERVICE) private readonly fwdPriceService: IPriceService;

    quoteObservable (request: Partial<IQuoteRequest>, errorHandler: MonoAction<string>): Observable<IPriceProviderQuote> {
        if (!Boolean(request)) {
            return of(EMPTY_QUOTE);
        }

        let resultFeed = of(EMPTY_QUOTE);

        switch (request.productType) {
            case 'spot':
            case 'pending':
                resultFeed = this.espPriceService.quoteObservable(request).pipe(
                    map(quoteResponse => ({
                        quoteResponse: quoteResponse,
                        isStarted: true,
                    })),
                );
                break;
            case 'forward':
            case 'swap':
                resultFeed = this.fwdPriceService.quoteObservable(request).pipe(
                    map(quoteResponse => ({
                        quoteResponse: quoteResponse,
                        isStarted: true,
                    })),
                );
                break;
            default:
                return of(EMPTY_QUOTE);
        }

        return concat(of(EMPTY_QUOTE), resultFeed, of(EMPTY_QUOTE)).pipe(
            catchError((err) => {
                errorHandler?.(err);
                return throwError(err);
            }));
    }
}
